
import styles from "./Privacy.module.css"

export const Privacy = () => {
    return (
        <>

            <div className={styles.privacyContainer}>
                <h1 className={styles.privacyTitle}>Privacy Policy</h1>

                <p>We recognise the importance of the privacy and the security of your personal information and this privacy notice explains what we do to look after your personal data -</p>

                <p><a href="https://www.growthco.uk/media/qtihwh1x/group-privacy-notice-version-mar-2024.pdf" target="_blank" rel="noreferrer" className={styles.link}>The Growth Company Group Privacy Notice <span className="gcicon-right"></span></a></p>

                <p>It tells you:</p>
                <ul>
                    <li>Where and how we collect your personal information</li>
                    <li>What we do with your information and how we keep it secure</li>
                    <li>What your privacy rights are and how the law protects you</li>
                    <li>How we look after your personal data</li>
                    <li>Your rights over any personal information we hold about you</li>
                    <li>How to contact us with any queries that you have</li>
                </ul>
            </div>
        </>
    );
};